import { SET_AUTHENTICATED } from './actions'


const initState = false

export const authentication = (state = initState, action) => {
    switch (action.type) {
      case SET_AUTHENTICATED:
        return action.authenticated
      default:
        return state
    }
  }



// WEBPACK FOOTER //
// ./src/store/authentication/reducers.js